module.exports = __webpack_public_path__ + "static/img/callback2.a24dfb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/callback/callback2.png
// module id = ibcn
// module chunks = 0